// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2U3pP","inner":"Footer_inner__2Kwha","nextIcon":"Footer_nextIcon__3Clz2","innerLeft":"Footer_innerLeft__2Xb8C"};